import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAward, FiExternalLink, FiUsers, FiCheck } = FiIcons;

const InqaCoaching = () => {
  const inqaLink = "https://www.inqa.de/DE/angebote/inqa-coaching/informationen-fuer-kmu/uebersicht.html";

  return (
    <section id="inqa" className="py-16 bg-white border-y border-gray-100">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto bg-azure-50 rounded-3xl p-8 md:p-12 border border-azure-100 relative overflow-hidden">
          <div className="absolute top-0 right-0 p-8 opacity-10">
            <SafeIcon icon={FiAward} className="text-9xl text-azure-600" />
          </div>
          
          <div className="relative z-10">
            <div className="inline-flex items-center bg-white px-4 py-2 rounded-full text-azure-600 text-sm font-bold mb-6 border border-azure-100 shadow-sm">
              <SafeIcon icon={FiUsers} className="mr-2" /> Beteiligungsorientierter Prozess
            </div>
            
            <h2 className="text-2xl md:text-3xl font-bold text-black mb-6">
              Geförderte Begleitung Ihres Veränderungsprozesses
            </h2>
            
            <p className="text-gray-700 text-lg mb-8 leading-relaxed">
              Wenn tiefgreifende Veränderung im Unternehmen notwendig ist, nutzen wir das methodische Rahmenwerk des <strong>INQA-Coachings</strong>. Hier steht nicht die Technik im Vordergrund, sondern die gemeinsame Entwicklung zukunftsfähiger Arbeitsweisen.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mb-10">
              {[
                "Prozesse gemeinsam mit Beschäftigten verstehen",
                "Digitale Arbeitsorganisation entwickeln",
                "Entscheidungsprozesse transparent machen",
                "Neue Arbeitsabläufe direkt im Alltag testen",
                "Veränderungsprozess aktiv begleiten",
                "Lernprozesse im Unternehmen anstoßen"
              ].map((item, i) => (
                <div key={i} className="flex items-center text-gray-700 text-sm">
                  <SafeIcon icon={FiCheck} className="text-azure-600 mr-2 flex-shrink-0" />
                  {item}
                </div>
              ))}
            </div>

            <div className="bg-white/60 backdrop-blur-sm p-5 rounded-2xl border border-azure-100 mb-8">
              <p className="text-azure-900 text-sm italic">
                <strong>Hinweis zur System-Architektur:</strong> Im Rahmen des INQA-Coachings ist die Erstellung einer System-Architektur möglich – jedoch als <strong>Ergebnis eines gemeinsamen Beteiligungsprozesses</strong>, nicht als isolierte Hauptleistung.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
              <a 
                href={inqaLink} 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center bg-azure-600 text-white px-6 py-3 rounded-xl font-bold hover:bg-azure-700 transition-all shadow-md"
              >
                Details zur INQA-Förderung <SafeIcon icon={FiExternalLink} className="ml-2" />
              </a>
              <span className="text-sm text-azure-600 font-bold bg-white px-3 py-1 rounded-full border border-azure-100">
                Bis zu 80% Zuschuss möglich
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InqaCoaching;